import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import SelectField from "./SelectField";

const allAuthoritarian = [
  { id: 1, name: "Si" },
  { id: 2, name: "No" },
];

export default function DistributorAuthoritarianField(props) {
  return (
    <SelectField
      {...props}
      displayText={
        <span>
          ¿Es autoritario? *
          <Tooltip title="Si el distribuidor es autoritario, las farmacias asociadas solo podrán registrar ventas mediante importación de planillas y no desde la web, para el programa asociado.">
            <IconButton
              size="small"
              aria-label="Información sobre distribuidor autoritario"
            >
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </span>
      }
      id="authoritarian"
      label="Seleccione"
      name="authoritarian"
      allValues={allAuthoritarian}
    />
  );
}
